import { AfterViewInit, Directive, ElementRef, Input, OnChanges, OnInit } from '@angular/core';
import { Util } from '@libs/utilities/util';


@Directive({
    selector: '[ngLoadingSpinner]'
})
export class NgLoadingSpinnerDirective implements OnInit, OnChanges, AfterViewInit {

	@Input() ngLoadingSpinner	: boolean = false;			// show or hide the spinner (true means show)
	@Input() background			: string  = null!;
	@Input() height				: string  = null!;
	@Input() width				: string  = null!;

	private wrapper: HTMLDivElement = null!;

	constructor(
		private elementRef: ElementRef<HTMLElement>
	) {
		// Initialize / Create loading wrapper
		this.elementRef.nativeElement.style.position = 'relative';
		const loadingSpinner: HTMLDivElement = this.createLoadingWrapper();
		this.elementRef.nativeElement.appendChild(loadingSpinner);
	}

	ngOnInit(): void {

		//0 - get loading-spinner wrapper
		this.wrapper = this.elementRef.nativeElement.querySelector('.ng-loading-spinner')!;

		//1 - set background, height and width
		if (!Util.String.isEmpty(this.background))	this.wrapper.style.background = this.background;
		if (!Util.String.isEmpty(this.height)) 		this.wrapper.style.height	  = this.height;
		if (!Util.String.isEmpty(this.width))  		this.wrapper.style.width 	  = this.width;
	}

	ngAfterViewInit(): void {
		this.showHideLoader();
	}

	ngOnChanges(): void {
		this.showHideLoader();
	}


	/**------------------------------------------------------
	 * Helper Function
	 */
	showHideLoader(): void {

		//0 - was the spinner already created?
		if (!this.wrapper) return;

		//1 - show / hide the loader
		this.wrapper.style.display = this.ngLoadingSpinner ? 'flex' : 'none';
	}

	//** Loading div wrapper */
	createLoadingWrapper(): HTMLDivElement {

		//0 - create parent div element and add class
		const wrapper: HTMLDivElement = document.createElement('div');
		wrapper.setAttribute('class', 'ng-loading-spinner');

		//1 - create child div element and add class
		const loader: HTMLDivElement = wrapper.appendChild(document.createElement('div'));
		loader.setAttribute('class', 'spinner-border text-primary me-2');
		loader.setAttribute('role', 'status');

		//2 - return wrapper
		return wrapper;
	}
}
